/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import MediaPrepHeaderSection from "../../../../common/commonComponents/mediaPrepheaderSection";
import MediaPrepPageHeader from "../../../../common/commonComponents/mediaPrepPageHeader";
import { MediaSolutionProductMasterService,} from "../../../../../service/mediaSolutionProductMaster";

interface SolutionProductMasterDetailsProps  {
  productId: string;
  onBack: () => void;
}

const SolutionProductMasterDetails: React.FC<SolutionProductMasterDetailsProps > = ({ productId, onBack }) => {
  const [product, setProduct] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    const fetchProduct = async () => {
        setLoading(true);
        try {
        const response =
            await MediaSolutionProductMasterService.getSolutionProductById(productId);

        if (response?.data?.length > 0) {
            setProduct(response.data[0]); 
        } else {
            setProduct({});
        }
        } catch (error) {
        console.error("Error fetching product details", error);
        } finally {
        setLoading(false);
        }
    };

    if (productId) fetchProduct();
    }, [productId]);

  return (
    <div className="media-prep-scope">
        <MediaPrepHeaderSection />
        <MediaPrepPageHeader pageHeader={t('mediaSolutionProductMaster.details.title')} />
        {/* Sticky Header */}
        <div className="sticky top-[110px] z-40 bg-white border-b border-slate-200 px-10 py-3 flex items-center justify-between shadow-sm shrink-0">
        <div className="flex items-center gap-6">
            <button
            onClick={onBack}
            className="w-10 h-10 rounded-xl border border-slate-200 flex items-center justify-center text-slate-400 hover:text-[#FF7043] hover:bg-orange-50 transition-all"
            >
            <span className="material-symbols-outlined text-xl">
                {t('mediaPowderProductMaster.icons.arrow_back')}
            </span>
            </button>
            <div>

            <div className="flex items-center gap-3">
                <h2 className="text-xl font-black text-[#2D3E50] tracking-tight uppercase">
                {t('mediaSolutionProductMaster.details.solutionMaster')}
                {" "}
                {product?.solution_product_name || "-"}
                </h2>
                {/* <span className="px-3 py-1 bg-emerald-100 text-emerald-700 text-[10px] font-black uppercase rounded-full border border-emerald-200 tracking-widest">
                Active Spec
                </span> */}
            </div>

            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-[0.2em] mt-0.5">
                {t('mediaSolutionProductMaster.details.productID')}
                {" "}
                {product?.solution_product_name || "-"}
            </p>
            </div>
        </div>

        {/* <div className="flex items-center gap-4">
            <button className="flex items-center gap-2 px-6 py-2.5 bg-[#2D3E50] text-white rounded-xl font-black text-[11px] uppercase tracking-widest hover:brightness-110 shadow-lg shadow-slate-200 transition-all">
            <span className="material-symbols-outlined text-sm">
                {t('mediaSolutionProductMaster.icons.edit_note')}
            </span>
            {t('mediaSolutionProductMaster.details.editSpecification')}
            </button>
        </div> */}
        </div>

        <div className="flex-1 overflow-y-auto custom-scrollbar">

        <div className="p-10 max-w-5xl mx-auto space-y-10 pb-32">

            {/* PRODUCT IDENTIFICATION */}
            <section className="bg-white rounded-[2rem] border border-slate-200 shadow-sm overflow-hidden border-t-0">
            <div className="px-10 py-2 border-b border-slate-50 bg-white flex items-center justify-between">
                <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-2xl bg-orange-50 flex items-center justify-center text-[#FF7043]">
                    <span className="material-symbols-outlined font-black">
                    {t('mediaPowder.icons.inventory2')}
                    </span>
                </div>
                <h3 className="text-xs font-black text-[#2D3E50] uppercase tracking-widest mt-2">
                    {t('mediaSolutionProductMaster.details.productIdentification')}
                </h3>
                </div>
                {/* <span className="text-[10px] font-black text-slate-300 uppercase tracking-[0.2em]">
                Section 01
                </span> */}
            </div>

            <div className="p-10 flex justify-start gap-2">
                <div className="w-72 space-y-1.5">
                <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest">
                    {t('mediaSolutionProductMaster.details.manufacturerName')}
                </p>
                <p className="text-base font-black text-slate-700">
                    {product?.manufacturer_name || "-"}
                </p>
                </div>
                <div className="w-48 space-y-1.5">
                <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest">
                    {t('mediaSolutionProductMaster.details.Catalog')}
                </p>

                <p className="text-base font-black text-[#FF7043] font-mono">
                    {product?.catalog_number || "-"}
                </p>
                </div>
                <div className="w-48 space-y-1.5">
                <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest">
                    {t('mediaSolutionProductMaster.details.Category')}
                </p>
                <p className="text-base font-black text-slate-700 uppercase">
                    {product?.category_name || "-"}
                </p>
                </div>
            </div>
            </section>

            {/* STABILITY & STORAGE */}
            <section className="bg-white rounded-[2rem] border border-slate-200 shadow-sm overflow-hidden">

            <div className="px-10 py-2 border-b border-slate-100 bg-slate-50/30 flex items-center justify-between">
                <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-2xl bg-blue-100/50 flex items-center justify-center text-blue-600">
                    <span className="material-symbols-outlined font-black">
                    {t('mediaSolutionProductMaster.icons.thermostat')}
                    </span>
                </div>

                <h3 className="text-xs font-black text-[#2D3E50] uppercase tracking-widest mt-2">
                    {t('mediaSolutionProductMaster.details.stabilityStorage')}
                </h3>
                </div>
                {/* <span className="text-[10px] font-black text-slate-300 uppercase tracking-[0.2em]">
                Section 02
                </span> */}
            </div>

            <div className="p-10 grid grid-cols-3 gap-12">
                <div className="flex flex-col gap-1.5 px-6 py-4 bg-slate-50 border border-slate-100 rounded-2xl">
                <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest">
                    {t('mediaSolutionProductMaster.details.ShelfLife')}
                </p>
                <div className="flex items-baseline gap-2">

                    <span className="text-2xl font-black text-[#2D3E50]">
                    {product?.shelf_life || "-"}
                    </span>

                    <span className="text-[10px] font-black text-slate-500 uppercase">
                    {t('mediaSolutionProductMaster.details.Days')}
                    </span>
                </div>
                </div>
            </div>
            </section>

        </div>
        </div>
    </div>
    );
  };
export default SolutionProductMasterDetails;
